var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGift3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22.0 22.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,900 L0,900 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7567581,0 C16.9201613,0 17.0526257,0.132464442 17.0526257,0.295867613 L17.0526257,9.89884273 C17.0508368,10.5663713 16.5100562,11.1070197 15.8425272,11.1086454 L1.21009854,11.1086454 C0.542569545,11.1070197 0.00178895707,10.5663713 0,9.89884273 L0,0.295867613 C0,0.132464442 0.132464442,0 0.295867613,0 L16.7567581,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i2",
    x1: "25.1223176px",
    y1: "-7.23211058px",
    x2: "-3.51570024px",
    y2: "13.0353281px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8691553,0 L15.8691553,9.3071075 C15.8688294,9.64853296 15.5922172,9.92527745 15.250792,9.92576668 L0.618659179,9.92576668 C0.27711836,9.92544047 0.000326209219,9.64864832 0,9.3071075 L0,0 L15.8691553,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i4",
    x1: "-6.75213996px",
    y1: "0px",
    x2: "23.4744945px",
    y2: "8.05695831px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.957454,0 C20.3732278,0.000326065163 20.7102435,0.33720939 20.7107329,0.752983075 L20.7107329,3.04003972 C20.7099176,3.45558228 20.3729972,3.79210569 19.957454,3.79243106 L0.753278943,3.79243106 C0.33773571,3.79210569 0.000815303072,3.45558228 0,3.04003972 L0,0.752983075 C0.000489401939,0.33720939 0.337505098,0.000326065163 0.753278943,0 L19.957454,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3657187,0 C19.4548215,0 19.5272625,0.0721452832 19.5272625,0.161247849 L19.5272625,2.4483045 C19.5272625,2.53740706 19.4548215,2.60955235 19.3657187,2.60955235 L0.161543717,2.60955235 C0.0724410014,2.60955235 0,2.53740706 0,2.4483045 L0,0.161247849 C0,0.0721452832 0.0724410014,0 0.161543717,0 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i7",
    x1: "0px",
    y1: "-5.91447101px",
    x2: "21.9615436px",
    y2: "7.33242799px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6687584,0 C3.83216157,0 3.96462601,0.141908313 3.96462601,0.316961088 L3.96462601,11.5836599 C3.96462601,11.7587127 3.83216157,11.900621 3.6687584,11.900621 L0.295867613,11.900621 C0.132464442,11.900621 0,11.7587127 0,11.5836599 L0,0.316961088 C0,0.141908313 0.132464442,0 0.295867613,0 L3.6687584,0 Z M3.37289079,0.514820806 L0.591735226,0.514820806 L0.591735226,11.3505103 L3.37289079,11.3505103 L3.37289079,0.514820806 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36397521,0.128703566 L4.90234227,3.09526501 C5.06618093,3.23262709 5.08764445,3.47679854 4.95028236,3.64063721 C4.93573508,3.65798848 4.91969355,3.67403002 4.90234227,3.6885773 C4.79238033,3.78076922 4.65539529,3.8234325 4.5204226,3.81656714 C4.51613231,3.89339986 4.48665505,3.97065005 4.43239703,4.03536632 C4.41784974,4.0527176 4.40180821,4.06875913 4.38445693,4.08330642 L0.846089876,7.04986786 C0.641408254,7.22147262 0.343098087,7.22147262 0.138416465,7.04986786 C-0.0254221997,6.91250578 -0.0468857107,6.66833433 0.0904763712,6.50449567 C0.105023655,6.48714439 0.121065188,6.47110286 0.138416465,6.45655557 L3.67678352,3.48999413 C3.72765984,3.4473395 3.78432088,3.41528724 3.8438909,3.39383735 L0.656301801,0.722015855 C0.492463137,0.584653773 0.470999626,0.340482324 0.608361708,0.176643659 C0.622908992,0.159292382 0.638950524,0.14325085 0.656301801,0.128703566 C0.860983424,-0.0429011886 1.15929359,-0.0429011886 1.36397521,0.128703566 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i10",
    x1: "7.8456168px",
    y1: "-2.19906407px",
    x2: "-3.7250615px",
    y2: "12.9697943px",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C1B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81A77",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-335.0 -475.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 215.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.0 231.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(291.0 4.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.0 20.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.857142857143117 6.223876331821897)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.8290535831984016 8.058123171640545)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 17.0526257,0 17.0526257,11.1086454 0,11.1086454 0,0",
    stroke: "none",
    fill: "url(#i2)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.420788809081386 8.649858397522621)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15.8691553,0 15.8691553,9.92576668 0,9.92576668 0,0",
    stroke: "none",
    fill: "url(#i4)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 4.857427334847671)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 20.7107329,0 20.7107329,3.79243106 0,3.79243106 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5917352258820756 5.4491625607279275)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.5272625,0 19.5272625,2.60955235 0,2.60955235 0,0",
    stroke: "none",
    fill: "url(#i7)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.373053446222912 8.17829758122025)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.96462601,0 3.96462601,11.900621 0,11.900621 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.597552239604596 1.0658141036401503e-14) rotate(90.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.96648253e-13,-2.48023824e-12 5.04075873,-2.48023824e-12 5.04075873,7.17857143 -1.96648253e-13,7.17857143 -1.96648253e-13,-2.48023824e-12",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.36397521,0.128703566 L4.90234227,3.09526501 C5.06618093,3.23262709 5.08764445,3.47679854 4.95028236,3.64063721 C4.93573508,3.65798848 4.91969355,3.67403002 4.90234227,3.6885773 C4.79238033,3.78076922 4.65539529,3.8234325 4.5204226,3.81656714 C4.51613231,3.89339986 4.48665505,3.97065005 4.43239703,4.03536632 C4.41784974,4.0527176 4.40180821,4.06875913 4.38445693,4.08330642 L0.846089876,7.04986786 C0.641408254,7.22147262 0.343098087,7.22147262 0.138416465,7.04986786 C-0.0254221997,6.91250578 -0.0468857107,6.66833433 0.0904763712,6.50449567 C0.105023655,6.48714439 0.121065188,6.47110286 0.138416465,6.45655557 L3.67678352,3.48999413 C3.72765984,3.4473395 3.78432088,3.41528724 3.8438909,3.39383735 L0.656301801,0.722015855 C0.492463137,0.584653773 0.470999626,0.340482324 0.608361708,0.176643659 C0.622908992,0.159292382 0.638950524,0.14325085 0.656301801,0.128703566 C0.860983424,-0.0429011886 1.15929359,-0.0429011886 1.36397521,0.128703566 Z",
    stroke: "url(#i10)",
    strokeWidth: 0.9,
    fill: "none",
    strokeLinejoin: "round"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGift3);
export default __webpack_public_path__ + "static/media/icGift3.d4660c8243853f7f392ded91f8fff6ad.svg";
export { ForwardRef as ReactComponent };